import { RENDERMETHOD } from ".";

const renderEditor = (scene, container, type, editor_structure) => {
    if (type === 'glb') {
        scene.children.forEach(element => {
            switch(element.type) {
                case 'AmbientLight':
                    handleAmbientLight(element, container);
                    break;
                case 'DirectionalLight':
                    handleDirectionalLight(element, container);
                    break;
                case 'Group':
                    handleMeshes(element, container);
                    break;

            }
        })

        container.querySelector('#ambient_light').onchange = onChangeAmbientLight;
        container.querySelector('#directional_light').onchange = onChangeDirectionalLight;
    } else if (type === 'custom') {
        scene.children.forEach(element => {
            switch(element.type) {
                case 'AmbientLight':
                    handleAmbientLight(element, container);
                    break;
                case 'DirectionalLight':
                    handleDirectionalLight(element, container);
                    break;

            }
        });
        let mesh_container_id;
        editor_structure.forEach((element) => {
            mesh_container_id = addMeshControl(element.mesh, container);
            if (element.sections.length) {
                element.sections.forEach((section) => {
                    addSection(section, mesh_container_id);
                })
            }   
        })

        container.querySelector('#ambient_light').onchange = onChangeAmbientLight;
        container.querySelector('#directional_light').onchange = onChangeDirectionalLight;
        addListenersForMeshes(container)
    }
}

const AMBIENTLIGHTS = [];

const onChangeAmbientLight = (e) => {
    const value = e.target.value;
    AMBIENTLIGHTS.forEach((light) => {
        light.intensity = value;
    })
    RENDERMETHOD.renderer.render(RENDERMETHOD.scene, RENDERMETHOD.camera)
};

const handleAmbientLight = (ambient_light, container) => {
    const ambient_light_wrapper = container.querySelector('.ambient_light_wrapper')
    if (Boolean(ambient_light_wrapper)) {
        AMBIENTLIGHTS.push(ambient_light)
    } else {
        AMBIENTLIGHTS.push(ambient_light);
        container.querySelector('.light_section_control').innerHTML +=
            `<div class="ambient_light_wrapper">
                <div class="ambient_light_range">
                    <label class="form-label">Глобальный свет</label>
                    <input type="range" class="form-range" min="0" max="2" step="0.05" value="0.5" id="ambient_light">
                </div>
            </div>`
    }
}

const DIRECTIONALLIGHTS = [];

const onChangeDirectionalLight = (e) => {
    const value = e.target.value;
    DIRECTIONALLIGHTS.forEach((light) => {
        light.intensity = value;
    })
    RENDERMETHOD.renderer.render(RENDERMETHOD.scene, RENDERMETHOD.camera)
}


const handleDirectionalLight = (directional_light, container) => {
    const directional_light_wrapper = container.querySelector('.directional_light_wrapper')
    
    if (Boolean(directional_light_wrapper)) {
        DIRECTIONALLIGHTS.push(directional_light)
    } else {
        DIRECTIONALLIGHTS.push(directional_light);
        container.querySelector('.light_section_control').innerHTML +=
            `<div class="directional_light_wrapper">
                <div class="directional_light_range">
                    <label class="form-label">Направленный свет</label>
                    <input type="range" class="form-range" min="0" max="4" value="0.5" step="0.05" id="directional_light">
                </div>
            </div>`
    }
}

const MESHESCONTROLS = []

const handleMeshes = (model, container) => {
    model.children.forEach(child => {
        switch (child.type) {
            case 'Mesh':
                addMeshControl(child, container)
                break;
            default:
                child.visible = false;
        }
    })

    addListenersForMeshes(container)
}

const addSection = (section, mesh_container_id) => {
    document.querySelector(mesh_container_id).innerHTML +=
        `<div id="${section.id}">
            <hr style="margin: 4px 0;">
            <label class="form-label">${section.name}</label>
        </div>`
    section.tracks.forEach((track) => {
        addTrack(track.mesh, section.id);
    })
}

const addTrack = (mesh, section_id) => {
    document.querySelector(`#${section_id}`).innerHTML +=
        `<div class="submesh_wrapper" id="meshwrapper${MESHESCONTROLS.length}">
            <div class="mesh_range">
                <input class="form-check-input form-check-input-mesh" type="checkbox" value=${mesh.visible} mesh-id="${mesh.uuid}" id="meshvisible${MESHESCONTROLS.length}" ${mesh.visible ? "checked" : ""}>
                <label class="form-label form-label-mesh">${mesh.name}</label>
                <input type="range" class="form-range" min="0" max="1" step="0.01" mesh-id="${mesh.uuid}" id="meshopacity${MESHESCONTROLS.length}">
            </div>
        </div>`;
    MESHESCONTROLS.push(mesh);
}

const addMeshControl = (mesh, container) => {
    const mesh_id = `meshwrapper${MESHESCONTROLS.length}`
    container.querySelector('.mesh_section_control').innerHTML += 
        `<div class="mesh_wrapper" id="${mesh_id}">
            <div class="mesh_range">
                <input class="form-check-input form-check-input-mesh" type="checkbox" value=${mesh.visible} mesh-id="${mesh.uuid}" id="meshvisible${MESHESCONTROLS.length}" ${mesh.visible ? "checked" : ""}>
                <label class="form-label form-label-mesh">${mesh.name}</label>
                <input type="range" class="form-range" min="0" max="1" step="0.01" mesh-id="${mesh.uuid}" id="meshopacity${MESHESCONTROLS.length}">
            </div>
        </div>`

    MESHESCONTROLS.push(mesh);

    if (mesh.children.length) {
        mesh.children.forEach((child) => {
            addSubMeshControl(child, `#${mesh_id}`)
        })
    }

    return `#${mesh_id}`;
}

const addSubMeshControl = (mesh, wrapper_id) => {
    // mesh.material.transparent = true;
    // mesh.material.depthWrite = false;
    document.querySelector(wrapper_id).innerHTML +=
        `<div class="submesh_wrapper" id="meshwrapper${MESHESCONTROLS.length}">
            <div class="mesh_range">
                <input class="form-check-input form-check-input-mesh" type="checkbox" value=${mesh.visible} mesh-id="${mesh.uuid}" id="meshvisible${MESHESCONTROLS.length}" ${mesh.visible ? "checked" : ""}>
                <label class="form-label form-label-mesh">${mesh.name}</label>
                <input type="range" class="form-range" min="0" max="1" step="0.01" mesh-id="${mesh.uuid}" id="meshopacity${MESHESCONTROLS.length}">
            </div>
        </div>`

    MESHESCONTROLS.unshift(mesh)
}

const addListenersForMeshes = (container) => {
    let i = 0;
    MESHESCONTROLS.forEach(() => {
        container.querySelector(`#meshvisible${i}`).onchange = onChangeMeshVisible
        container.querySelector(`#meshopacity${i}`).onchange = onChangeMeshOpacity
        i++;
    })
}

const onChangeMeshVisible = (e) => {
    const value = !(e.target.getAttribute('value') === 'true');
    e.target.setAttribute('value', value);
    const mesh_id = e.target.getAttribute("mesh-id")
    const mesh = MESHESCONTROLS.find((control) => control.uuid === mesh_id)
    mesh.visible = value;
    RENDERMETHOD.renderer.render(RENDERMETHOD.scene, RENDERMETHOD.camera)
}

const onChangeMeshOpacity = (e) => {
    const value = e.target.value;
    const mesh_id = e.target.getAttribute("mesh-id")
    const mesh = MESHESCONTROLS.find((control) => control.uuid === mesh_id)
    mesh.material.opacity = Number(value);
    RENDERMETHOD.renderer.render(RENDERMETHOD.scene, RENDERMETHOD.camera)
}

export default {
    renderEditor,
}